import React from 'react'
import PropTypes from 'prop-types'
import './logo.css'

const Logo = () => {
  return (
    <div className="company-logo-lockup-new">
      <img
        src="/emblem-transparent.png"
        alt="Ateş Auto Amblem"
        className="company-logo-symbol-img"
        loading="eager"
      />
      <div className="company-logo-text-group">
        <span className="company-logo-brand-text">ATEŞ</span>
        <span className="company-logo-sub-text">AUTO DETAILING</span>
      </div>
    </div>
  )
}

Logo.defaultProps = {
  isOnDarkBackground: true,
}

Logo.propTypes = {
  isOnDarkBackground: PropTypes.bool,
}

export default Logo
